import { getPreviousQuarterAndYear } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getPreviousYearAndQuarter'
import { getQuartersUpToQuarter } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getQuartersUpToQuarter'
import { isVersionForGlobalPartner } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/isVersionForGlobalPartner'
import {
  joinData,
  mapQuarterlyTableDataToTotalData,
  mapSobAnalyticsReportJoinedToQuarterlyHierarchyNodes,
} from 'legacy/lut/components/widgets/public/partner360/helpers/report'
import { getChartData } from 'legacy/lut/components/widgets/public/partner360/helpers/report/sobAnalyticReport/chart/getChartData'

import { mapGeoMappingItem } from 'partner360/components/filters'
import { ISobAnalyticsReportInfo } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportInfo'
import { ISobAnalyticsReportJoined } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportJoined'

import { fetchSobAnalyticsReportsDataForPartner } from '../../../reports/api/fetchSobAnalyticsReportsDataForPartner'

import { getBusinessPerformanceDataGroupedByCategory } from './getBusinessPerformanceDataGroupedByCategory'
import { getBusinessPerformanceTotalData } from './getBusinessPerformanceTotalData'

interface IGetBusinessPerformanceData {
  fYear: number
  fQuarter: number
  partnerId: string
}
export const getBusinessPerformanceData = async ({
  fQuarter,
  fYear,
  partnerId,
}: IGetBusinessPerformanceData) => {
  const { year, quarter } = getPreviousQuarterAndYear(fYear, fQuarter)

  const isGlobalPartnerVersion = isVersionForGlobalPartner(partnerId)
  const res = await fetchSobAnalyticsReportsDataForPartner(year, partnerId)

  const joined = joinData<ISobAnalyticsReportInfo, ISobAnalyticsReportJoined>(
    res.Data,
    res.Partners
  )
  const geoMapping = res.GeoMapping.map(mapGeoMappingItem)
  const dataByCategory = getBusinessPerformanceDataGroupedByCategory(joined)
  return dataByCategory.map((el) => {
    const mappedData = mapSobAnalyticsReportJoinedToQuarterlyHierarchyNodes({
      geoMappings: geoMapping,
      data: el.data.filter((el) => !el.SubCategory),
      coverageData: el.data,
      currentFYear: year,
      quarters: getQuartersUpToQuarter(quarter),
      hasAppliedCuntriesFilter: true,
    })
    const marketTableData = isGlobalPartnerVersion
      ? mappedData
      : mappedData.filter((el) => !el.parentId).map((el) => ({ ...el, hasChildren: false }))
    return {
      Category: el.category,
      CollectedData: getBusinessPerformanceTotalData({
        data: mappedData,
      }),
      MarketTableData: marketTableData,
      MarketTableDataTotal: isGlobalPartnerVersion
        ? mapQuarterlyTableDataToTotalData({
            tableData: mappedData,
          })
        : undefined,
      ChartData: getChartData({
        data: el.data,
        shouldShowFutureYears: false,
        currentYear: year,
        getAllowedQuarters: () => {
          const quarters = getQuartersUpToQuarter(quarter)
          return quarters.map((q) => `Q${q}`).concat('FY')
        },
      }),
    }
  })
}
